<template>
  <div class="tag-input d-flex align-center">
    <div class="label font-weight-bold">{{label}}</div>

    <v-text-field v-if="type !== 'date'" :hide-details="mode != 'new' && tagValue && tagValue.length <= 50" :counter="rules ? 50 : null" dense single-line outlined :value="tagValue" :rules="rules" @input="onInput"></v-text-field>

    <!-- Date picker -->
    <v-menu
      v-if="type === 'date'"
      ref="dateMenu"
      v-model="dateMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="tagValue"
          :error-messages="dateErrorMessage"
          v-bind="attrs"
          v-on="on"
          readonly
          hide-details="auto"
          dense
          outlined
          append-icon="mdi-calendar"
          clearable
          @click:clear="clearDate"
        ></v-text-field>
      </template>
      <v-date-picker
        :value="dateValue"
        type="date"
        no-title
        scrollable
        class="ml-3"
        @input="onSelectDate"
      ></v-date-picker>
    </v-menu>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ml-3" v-bind="attrs" v-on="on" @click="deleteTag" icon>
          <v-icon color="red">mdi-minus</v-icon>
        </v-btn>
      </template>
      <span>{{$t('delete')}}</span>
    </v-tooltip>
  </div>
</template>

<script>

export default {
  name: 'TagInput',
  props: ['label', 'tagValue', 'rules', 'mode', 'type', 'dateErrorMessage', 'dateValue'],
  data () {
    return {
      dateMenu: false,
      date: null
    }
  },
  methods: {
    onInput (value) {
      this.$emit('update:tagValue', value)
    },
    onSelectDate (value) {
      this.$emit('update:tagValue', value)
      this.dateMenu = false
    },
    clearDate () {
      this.$emit('update:tagValue', '')
    },
    deleteTag () {
      this.$emit('delete-tag')
    }
  }
}

</script>

<style lang="sass" scoped>

.label
  padding: 0px 10px
  color: black
  min-width: 140px

.tag-input
  padding: 6px 10px
  background: #f1f1f1
  .v-input--is-focused
    background: white

</style>
